<template>
    <MaintenanceChecker
        :checkedParts="checkedParts"
        class="flex w-full"
    >
        <template slot="message">
            <div class="maintenance-mode__offer--terminal">
                <h2>{{ $t('Maintenance in progress')}}</h2>
            </div>
        </template>
        <div class="flex w-full">
            <div class="nav-sidebar">
                <SpecialsSidebar />
            </div>
            <div class="main--terminal">
                <SpecialTimeFilterContainer :class="isTimeFilterDropdownExpanded ? 'is-expanded' : ''" />
                <SpecialOfferContainer />
            </div>
            <div class="right-sidebar">
                <BetSlipContainer />
            </div>
        </div>
    </MaintenanceChecker>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import SpecialOfferContainer from
        '@src/terminal/app/modules/specialOffer/content/SpecialOfferContainer.vue';
    import SpecialTimeFilterContainer from
        '@src/terminal/app/modules/specialOffer/timeFilter/SpecialTimeFilterContainer.vue';
    import BetSlipContainer from '@src/terminal/app/modules/sportOffer/betslip/BetSlipContainer';
    import { MaintenanceType } from '@core/models/country/enums';
    import { SidebarId } from '@app/store/modules/ui/mobile/enums';
    import SpecialsSidebar from './sidebar/SpecialsSidebar';

    export default {
        name: 'SpecialContainer',
        created() {
            this.checkedParts = [
                // sport because it's defined in cms like that
                MaintenanceType.sport
            ];
            this.$watch('$route.params.timeFilter', function () {
                this.loadSpecialOffer();
            }, {
                immediate: true,
            });
        },
        computed: {
            ...mapGetters('ui/mobile', ['isSidebarOpen']),
            isTimeFilterDropdownExpanded() {
                return this.isSidebarOpen(SidebarId.specialsTimeFilter);
            }
        },
        methods: {
            ...mapActions('ui/mobile', [
                'toggleSidebar',
            ]),
            ...mapActions('data/specialOffer', [
                'loadSpecialOffer',
            ]),
            onTimeFilterClick() {
                this.toggleSidebar(SidebarId.specialsTimeFilter);
            },
        },
        components: {
            SpecialOfferContainer,
            BetSlipContainer,
            SpecialTimeFilterContainer,
            SpecialsSidebar,
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/specialOffer/SpecialContainer.vue